import { render, staticRenderFns } from "./ShippingServiceForm.vue?vue&type=template&id=0ac65ca5&scoped=true"
import script from "./ShippingServiceForm.vue?vue&type=script&lang=js"
export * from "./ShippingServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingServiceForm.vue?vue&type=style&index=0&id=0ac65ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac65ca5",
  null
  
)

export default component.exports